var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGolden(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 16,
    viewBox: "0 0 9 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.46115 0.201172L4.36621 0.558426V10.9251L4.46115 11.03L8.80842 8.18557L4.46115 0.201172Z",
    fill: "#F29D1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.46128 0.201172L0.114014 8.18557L4.46128 11.03V5.99837V0.201172Z",
    fill: "#EEC31A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.46122 11.9411L4.40771 12.0133V15.7061L4.46122 15.8792L8.81109 9.09814L4.46122 11.9411Z",
    fill: "#F29D1F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.46128 15.8792V11.9411L0.114014 9.09814L4.46128 15.8792Z",
    fill: "#EEC31A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.46118 11.0301L8.8084 8.18576L4.46118 5.99854V11.0301Z",
    fill: "#E47C25"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.114014 8.18576L4.46123 11.0301V5.99854L0.114014 8.18576Z",
    fill: "#F29D1F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGolden);
export default __webpack_public_path__ + "static/media/golden.189e43a739e6ae481908c4802e30b90d.svg";
export { ForwardRef as ReactComponent };